import Swiper, { Navigation, Pagination } from 'swiper';
import barba from '@barba/core';
import { initCursorElements } from './customCursor';

Swiper.use([Navigation, Pagination]);

const initSlider = () => {
	const sliders = document.querySelectorAll('.swiper:not(.swiper-initialized):not(.reference-slider)');
    const referenceSliders = document.querySelectorAll('.reference-slider:not(.swiper-initialized)');

	if(sliders.length) {
		sliders.forEach((slider) => {
			const swiper = new Swiper(slider, {
				spaceBetween: 16,
				loop: true,
				navigation: {
					prevEl: '.swiper-prev',
					nextEl: '.swiper-next',
				},
				pagination: {
					el: slider.parentNode.querySelector('.swiper-pagination'),
					clickable: true,
				},
				on: {
					init: () => {
						initCursorElements(slider.parentNode.querySelector('.swiper-pagination'));
					},
				},
			});
		});
	}

    if(referenceSliders.length) {
        referenceSliders.forEach((slider) => {
            const swiperReference = new Swiper(slider, {
                spaceBetween: 16,
                slidesPerView: 1.3,
                grabCursor: true,
                centeredSlides: true,
                breakpoints: {
                    768: {
                        spaceBetween: 32,
                        slidesPerView: 3,
                        centeredSlides: false,
                    },
                },
                on: {
                    slideChange: (e) => {
                        setTimeout(() => {
                            const videos = e.wrapperEl.querySelectorAll('.reference-slider__video');

                            if (videos.length > 0) {
                                videos.forEach((video) => {
                                    video.pause();
                                });
                            }

                            const activeSlide = e.wrapperEl.querySelector('.swiper-slide-active .reference-slider__video');

                            if (activeSlide) {
                                activeSlide.play();
                            }
                        }, 500);
                    },
                },
            });
        });
    }
};

barba.hooks.beforeEnter(initSlider);
document.addEventListener('DOMContentLoaded', initSlider);
